document.addEventListener('DOMContentLoaded', (e) => {
	const subnav = document.querySelector('#subnav');
	if (subnav) {
		let sections = document.querySelectorAll('#subnav > ul li:not(.a-subnav-link) a, #subnav > .block-inline-blocksubnavigation > ul li:not(.a-subnav-link) a');
		let section_form = document.querySelector('.m-report__subnav__form');
		let toolbar = document.querySelector('#toolbar-administration');
		let toolbar_height = 0;

		let topics_mega = document.querySelector(
			'.m-topicmenu--dropdown > .m-topicmenu > li'
		);
		if (topics_mega) {
			topics_mega.addEventListener('mouseover', function (e) {
				subnav.style.zIndex = '90';
			});
			topics_mega.addEventListener('mouseout', function (e) {
				subnav.removeAttribute('style');
			});
		}

		function sectionScroll(event, hash_id) {
			event.preventDefault();

			//console.log(decodeURI(hash_id));
			let hash = document.querySelector(decodeURI(hash_id));
			// console.log('toolbar_height', toolbar_height);
			// console.log('hash top', hash.getBoundingClientRect().top);

			/*
			 * Ideally this is all we'd need.
			 * UntiL Safari supports ScrollIntoViewOptions though.
			 * There's no real point in trying.
			 */
			// hash.scrollIntoView({
			// 	behavior: 'smooth',
			// 	block: 'center',
			// 	inline: 'nearest',
			// });

			let topScroll = hash.getBoundingClientRect().top;
			let ycoord = topScroll + window.pageYOffset - subnav.scrollHeight;

			if (document.querySelector('body').classList.contains('user-logged-in')) {
				ycoord -= 80;
			}
			// console.log('subnav scrollHeight', subnav.scrollHeight);
			// console.log('ycoord', ycoord);
			window.scroll(0, ycoord);
		}

		if (toolbar) {
			//console.log('onload toolbar height: ' + toolbar.scrollHeight);
			toolbar_height = toolbar.scrollHeight;
			//subnav.style.top = toolbar_height + 'px';
		}

		for (let section of sections) {
      section.addEventListener('click', function (e) {
				  jQuery('#subnav > ul li, #subnav > .block-inline-blocksubnavigation > ul li').find('a').removeClass('active');
				  jQuery(section).addClass('active');
				  sectionScroll(e, section.hash);
			});
		}

		jQuery(document).ready(function ($) {
			$('#section_choice')
				.chosen({ disable_search_threshold: 50, width: '100%' })
				.change(function (e) {
					//console.log($(this).val());
					let value = $(this).val();
					sectionScroll(e, `#${value}`);
          //this handles new tab sections, see also threats.js
					if (value == "designations") {
						jQuery('.m-tabs__menu .m-tabs__link').removeClass('j-active');
						jQuery('.m-tabs__menu .m-tabs__link--a').addClass('j-active');
						jQuery('.m-tabs__tab').removeClass('m-tabs__tab--active');
						jQuery('.o-report__designations').addClass('m-tabs__tab--active');
					}
          if (value == "associations") {
						jQuery('.m-tabs__menu .m-tabs__link').removeClass('j-active');
						jQuery('.m-tabs__menu .m-tabs__link--b').addClass('j-active');
						jQuery('.m-tabs__tab').removeClass('m-tabs__tab--active');
						jQuery('.o-report__associations').addClass('m-tabs__tab--active');
					}
          if (value == "mediacoverage") {
						jQuery('.m-tabs__menu .m-tabs__link').removeClass('j-active');
						jQuery('.m-tabs__menu .m-tabs__link--c').addClass('j-active');
						jQuery('.m-tabs__tab').removeClass('m-tabs__tab--active');
						jQuery('.o-report__media').addClass('m-tabs__tab--active');
					}
          if (value == "rhetoric") {
						jQuery('.m-tabs__menu .m-tabs__link').removeClass('j-active');
						jQuery('.m-tabs__menu .m-tabs__link--d').addClass('j-active');
						jQuery('.m-tabs__tab').removeClass('m-tabs__tab--active');
						jQuery('.o-report__rhetoric').addClass('m-tabs__tab--active');
					}
				});
		});

		section_form
			.querySelector('#section_choice')
			.addEventListener('change', function (e) {
				//console.log('section changed');
				sectionScroll(e, `#${this.value}`);
			});
	}

	// on scroll behavior
	jQuery(window).on('scroll', function () {
		if (jQuery('#subnav')) {
			let subnav = document.querySelector('#subnav');
			let scroll_adjustment = 5;

			if (document.querySelector('#toolbar-administration')) {
				let toolbar = document.querySelector('#toolbar-administration');
				scroll_adjustment += toolbar.offsetTop;
			}
			jQuery('.subnav-target').each(function () {
				if (
					window.scrollY + subnav.scrollHeight >=
					jQuery(this).offset().top - scroll_adjustment
				) {
					var id = jQuery(this).attr('id');
					// console.log(id);
					jQuery('#subnav > ul li a').removeClass('active');
					jQuery('#subnav > ul li a[href="#' + id + '"]').addClass('active');
				}
			});
		}
	});
});

document.addEventListener('DOMContentLoaded', (e) => {
	jQuery('.m-report__subnav--mobile .m-report__subnav__list').each(function () {
		var list = jQuery(this),
			select = jQuery(document.createElement('select'))
				.addClass(['m-report__subnav__form', 'm-report__subnav__form--hidden'])
				.insertBefore(jQuery(this).hide());

		jQuery('>li a', this).each(function () {
			var target = jQuery(this).attr('target'),
				option = jQuery(document.createElement('option'))
					.appendTo(select)
					.val(this.href)
					.html(jQuery(this).html())
					.click(function () {
						if (target === '_blank') {
							window.open(jQuery(this).val());
						} else {
							window.location.href = jQuery(this).val();
						}
					});
		});
		list.remove();
	});
});
